// Yeni kayıtta bekleyen şartnameleri (Kaydet sonrası) yükler; hata olursa diğerlerine devam eder
export const uploadPendingSpecs = async (prospectId, pending, http, toastApiError) => {
  let ok = 0;
  for (const p of pending || []) {
    try {
      const fd = new FormData(); fd.append("file", p.file); fd.append("kind", "sartname"); fd.append("description", p.description || "");
      await http.post(`/prospects/${prospectId}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }); ok += 1;
    } catch (err) { toastApiError(err); }
  }
  return ok;
};

// Satış Pazarlama (müşteri adayı) sabitleri ve yardımcıları — kural: e-posta/KEP dışında tüm metinler BÜYÜK HARF
export const up = (s) => String(s ?? "").toLocaleUpperCase("tr");
export const asciiLow = (s) => String(s ?? "").replace(/İ/g, "i").replace(/I/g, "i").toLowerCase();   // e-posta / KEP: noktasız ı üretmez
export const CONTRACT_RATE = 0.00948;   // tahmini sözleşme gideri: işin toplam tutarının binde 9,48'i
export const EMPTY_SURVEY = { date: "", staff: "", notes: "" };
// Teklif veren firma seçenekleri (grup şirketleri)
export const BIDDER_COMPANIES = ["WILCO A.Ş.", "WILCO BORDROLAMA", "WILCO END."];
export const EMPTY_PROSPECT = {
  bidder_company: "",
  title: "", billing_address: "", tax_office: "", tax_number: "", email: "", kep_address: "", phone: "", fax: "",
  due_days: "", due_note: "", work_name: "", tender_no: "",
  personnel_count: "", personnel_note: "", region_count: "", region_note: "", branch_count: "", branch_note: "", m2: "", m2_note: "",
  surveys: [{ ...EMPTY_SURVEY }, { ...EMPTY_SURVEY }, { ...EMPTY_SURVEY }],
  estimated_total: "", temp_guarantee: "", final_guarantee: "", verdict: "", general_comment: "", elimination_reason: "",
  pending_specs: [],   // yeni kayıtta Kaydet'e kadar bekleyen şartname dosyaları (API'ye gönderilmez)
};
export const verdictCls = (v) => (v === "OLUMLU" ? "bg-emerald-600 text-white border-emerald-600" : v === "OLUMSUZ" ? "bg-red-600 text-white border-red-600" : "bg-slate-100 text-slate-500 border-slate-300");
export const toProspectForm = (p) => ({
  ...EMPTY_PROSPECT, ...p,
  due_days: p.due_days ?? "", personnel_count: p.personnel_count ?? "", region_count: p.region_count ?? "", branch_count: p.branch_count ?? "", m2: p.m2 ?? "",
  estimated_total: p.estimated_total || "", temp_guarantee: p.temp_guarantee || "", final_guarantee: p.final_guarantee || "",
  surveys: [0, 1, 2].map((i) => ({ ...EMPTY_SURVEY, ...((p.surveys || [])[i] || {}) })),
});
const numOrNull = (v) => (v === "" || v === null || v === undefined ? null : Number(String(v).replace(",", ".")) || 0);
export const toProspectApi = ({ pending_specs, ...f }, parseTL) => ({
  ...f,
  due_days: numOrNull(f.due_days), personnel_count: numOrNull(f.personnel_count), region_count: numOrNull(f.region_count), branch_count: numOrNull(f.branch_count), m2: numOrNull(f.m2),
  estimated_total: parseTL(f.estimated_total) ?? 0, temp_guarantee: parseTL(f.temp_guarantee) ?? 0, final_guarantee: parseTL(f.final_guarantee) ?? 0,
});
